"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadAttributeSaga = exports.loadAttributeWorker = void 0;
var tslib_1 = require("tslib");
var effects_1 = require("redux-saga/effects");
var slice_1 = require("../store/slice");
var sagas_1 = require("../common/sagas");
var filterSelectors_1 = require("../filter/filterSelectors");
var loadAttributeByDisplayForm_1 = require("./loadAttributeByDisplayForm");
/**
 * @internal
 */
function loadAttributeWorker() {
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.takeLatest([slice_1.actions.loadAttributeRequest.match, slice_1.actions.loadAttributeCancelRequest.match], loadAttributeSaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
exports.loadAttributeWorker = loadAttributeWorker;
/*
 * @internal
 */
function loadAttributeSaga(action) {
    var correlation, displayFormRef, context, attribute, error_1;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (slice_1.actions.loadAttributeCancelRequest.match(action)) {
                    // Saga was triggered by cancel request - do nothing, just jump to finally statement
                    return [2 /*return*/];
                }
                correlation = action.payload.correlation;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 7, 9, 13]);
                return [4 /*yield*/, effects_1.select(filterSelectors_1.selectAttributeFilterDisplayForm)];
            case 2:
                displayFormRef = _a.sent();
                return [4 /*yield*/, effects_1.call(sagas_1.getAttributeFilterContext)];
            case 3:
                context = _a.sent();
                return [4 /*yield*/, effects_1.put(slice_1.actions.loadAttributeStart({ correlation: correlation }))];
            case 4:
                _a.sent();
                return [4 /*yield*/, effects_1.call(loadAttributeByDisplayForm_1.loadAttributeByDisplayForm, context, displayFormRef)];
            case 5:
                attribute = _a.sent();
                return [4 /*yield*/, effects_1.put(slice_1.actions.loadAttributeSuccess({ attribute: attribute, correlation: correlation }))];
            case 6:
                _a.sent();
                return [2 /*return*/, attribute];
            case 7:
                error_1 = _a.sent();
                return [4 /*yield*/, effects_1.put(slice_1.actions.loadAttributeError({ error: error_1, correlation: correlation }))];
            case 8:
                _a.sent();
                return [3 /*break*/, 13];
            case 9: return [4 /*yield*/, effects_1.cancelled()];
            case 10:
                if (!_a.sent()) return [3 /*break*/, 12];
                return [4 /*yield*/, effects_1.put(slice_1.actions.loadAttributeCancel({ correlation: correlation }))];
            case 11:
                _a.sent();
                _a.label = 12;
            case 12: return [7 /*endfinally*/];
            case 13: return [2 /*return*/];
        }
    });
}
exports.loadAttributeSaga = loadAttributeSaga;
//# sourceMappingURL=loadAttributeSaga.js.map